var _excluded = ["children", "pageId", "pageMetricsAttributes", "legacyWeb", "includeGTM", "includeExperiments"];
var _jsxFileName = "/repo/packages/webassets/src/components/BasePage/index.tsx",
  _this = this;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useContext } from 'react';
import { PageMetricsProvider, MetricsTracker } from '@sm/metrics';
import { ExperimentProvider } from '../Experiments';
import BasePageHead from './BasePageHead';
import { StaticContext } from '../..';
import BasePageBody from './BasePageBody';
import { useGTM, useInitialRender } from './hooks';
var BasePage = function BasePage(_ref) {
  var children = _ref.children,
    pageId = _ref.pageId,
    pageMetricsAttributes = _ref.pageMetricsAttributes,
    legacyWeb = _ref.legacyWeb,
    _ref$includeGTM = _ref.includeGTM,
    includeGTM = _ref$includeGTM === void 0 ? true : _ref$includeGTM,
    _ref$includeExperimen = _ref.includeExperiments,
    includeExperiments = _ref$includeExperimen === void 0 ? true : _ref$includeExperimen,
    bodyProps = _objectWithoutProperties(_ref, _excluded);
  var isInitialRender = useInitialRender();
  var _useContext = useContext(StaticContext),
    user = _useContext.user,
    environment = _useContext.environment,
    clientConfig = _useContext['client-config'],
    GDPR = _useContext.GDPR;
  var country = environment.countryCode;
  var gtmId = clientConfig.gtmId,
    loggingAPIPath = clientConfig.loggingAPIPath,
    dataAnalyticsAPIPath = clientConfig.dataAnalyticsAPIPath,
    amplitudeToken = clientConfig.amplitudeToken,
    _clientConfig$amplitu = clientConfig.amplitudeForceAnonymous,
    amplitudeForceAnonymous = _clientConfig$amplitu === void 0 ? false : _clientConfig$amplitu;

  // init global metrics
  if (isInitialRender) {
    MetricsTracker.initialize({
      user: user,
      dataAnalyticsAPIPath: dataAnalyticsAPIPath,
      loggingAPIPath: loggingAPIPath,
      country: country,
      legacyWeb: legacyWeb,
      pageId: pageId,
      gtmId: gtmId,
      amplitudeToken: amplitudeToken,
      forceAnonymous: amplitudeForceAnonymous
    });
  }
  useGTM(includeGTM);
  var BasePageInternals = /*#__PURE__*/React.createElement(PageMetricsProvider, {
    pageId: pageId,
    attributes: pageMetricsAttributes,
    GDPR: GDPR,
    user: user,
    country: country,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(BasePageHead, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(BasePageBody, Object.assign({}, bodyProps, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 7
    }
  }), children));
  if (includeExperiments) {
    return /*#__PURE__*/React.createElement(ExperimentProvider, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 12
      }
    }, BasePageInternals);
  }
  return BasePageInternals;
};
export default BasePage;
//# sourceMappingURL=index.js.map